import React from 'react'
// views
import {
  MetadataContent,
  MetadataLabel,
  MetadataValue
} from 'components/Modals/PlanItems/components/ActivitiesList/components/Activities/components/ResourceActivity/views'

interface IIncomingProps {
  label: string
  children?: React.ReactNode
}

const MetaContent: React.FunctionComponent<IIncomingProps> = ({ label, children }) => {
  return (
    <MetadataContent>
      <MetadataLabel>{label}</MetadataLabel>
      <MetadataValue>{children}</MetadataValue>
    </MetadataContent>
  )
}

export default MetaContent
